/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import clsx from "clsx";
import { downloadImageCommon, exportChatFile, currencyFormatInt } from "../../../../helpers/utilities";
import { NavLink } from "react-router-dom";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import useMediaQuery from '@mui/material/useMediaQuery';

export const Location = (props) => {
    const { title, salesDashboardDetails } = props;
    const location = useRef(null);
    const titleRef = useRef(null);
    const classes = customStyles();
    //const [dataSort, setDataSort] = useState([]);
    const [height, setHeight] = useState('');
    const [datas, setDatas] = useState([]);
    const [days, setDays] = useState(30);
    const [type, setType] = useState('areas');
    const [typeTitle, setTypeTitle] = useState('Area');
    const colors = [classes.greenbox, classes.orangebox, classes.bluebox];
    const border = [classes.rightgreenBorder, classes.rightorangeBorder, classes.rightblueBorder];
    const tBorder = [classes.topgreenBorder, classes.toporangeBorder, classes.topblueBorder];
    const [totalAreaValue, setTotalAreaValue] = useState('top_saled_area_30');
    const [totalSalesValue, setTotalSalesValue] = useState('city_location_30');
    const [totalCityValue, setTotalCityValue] = useState('top_saled_city_30');
    const mobileDevice = useMediaQuery('(min-width:1300px)');
    let cI = 0;
    const handleChange = (value) => {
        setDatas(salesDashboardDetails[value]);
        setTotalSalesValue(value);
        if (value === 'city_location_120') {
            setDays(120);
            setTotalAreaValue('top_saled_area_120');
            setTotalCityValue('top_saled_city_120')
        } else if (value === 'city_location_300') {
            setDays(300);
            setTotalAreaValue('top_saled_area_300');
            setTotalCityValue('top_saled_city_300')
        } else {
            setDays(30);
            setTotalAreaValue('top_saled_area_30');
            setTotalCityValue('top_saled_city_30')
        }
        setType('areas');
    }

    const handleTypeChange = (value) => {
        setType(value);
        if (value === 'pins') {
            setTypeTitle('Pincode');
        } else if (value === 'state') {
            setTypeTitle('State');
        } else {
            setTypeTitle('Area');
        }
    }

    useEffect(() => {
        if (salesDashboardDetails) {
            setDatas(salesDashboardDetails['city_location_30']);
        }
    }, [salesDashboardDetails]);

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(location.current, title, type);
        }
    }

    useEffect(() => {
        let h = `calc(100% - ${titleRef.current.clientHeight - 20}px)`;
        setHeight(h);
    }, [titleRef]);

    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total'],
        [salesDashboardDetails[totalAreaValue]?.name, salesDashboardDetails[totalCityValue]?.name, ''],
        [salesDashboardDetails[totalAreaValue]?.total, salesDashboardDetails[totalCityValue]?.total, salesDashboardDetails[totalSalesValue].reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v.total)), 0)]];

        newHead[newHead.length + 1] = ['City', 'Sales Total', type, 'Sales Total'];
        datas.map((data, i) => {
            newHead[newHead.length] = [data?.name, data.total];
            data[type].map((dt, di) => {
                newHead[newHead.length] = ['', '', dt?.name || dt?.code, dt.total];
            });
        });
        exportChatFile(title, newHead);
    }

    useEffect(() => {
        let a = [];
        let k = [];
        if (datas.length > 0) {
            datas.map((d, i) => {
                a = [];
                d[type].map((t, ti) => {
                    a.push(t?.total);
                });
                a.sort((a, b) => a - b)
                k.push(a)
            });

            // setDataSort(k);
        }
    }, [datas]);


    return (
        <div ref={location} className={clsx(classes.totalChartDiv, { [classes.mobileDevice]: !mobileDevice })}>
            <div ref={titleRef}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                    {
                        !mobileDevice && <br />
                    }
                    <span className={classes.lastDays}>{`Last ${days} days`}</span>
                    <span className={classes.lastDaysRadio}>
                        <RadioGroup
                            row
                            defaultValue={"city_location_30"}
                            onChange={(e) => handleChange(e.target.value)}>
                            <FormControlLabel value="city_location_30" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="30" />
                            <FormControlLabel value="city_location_120" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="120" />
                            <FormControlLabel value="city_location_300" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="300" />
                        </RadioGroup>
                    </span>
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <Row gutter={25} display={"flex"} className={clsx(classes.salesByLoc, classes.padding10t)}>
                    <Col span={8}>
                        <p>Top Area Sales Total</p>
                        <p className={classes.salesByLocPara}>{salesDashboardDetails && salesDashboardDetails[totalAreaValue]?.name}</p>
                        <h3>₹ {currencyFormatInt(salesDashboardDetails && (salesDashboardDetails[totalAreaValue]?.total || 0))}</h3>
                    </Col>
                    <Col span={8} className={clsx(classes.borderRight, classes.borderLeft)}>
                        <p>Top City Sales Total</p>
                        <p className={classes.salesByLocPara}>{salesDashboardDetails && salesDashboardDetails[totalCityValue]?.name}</p>
                        <h3>₹ {currencyFormatInt(salesDashboardDetails && (salesDashboardDetails[totalCityValue]?.total || 0))}</h3>
                    </Col>
                    <Col span={8} className={clsx(classes.textAlignRight)}>
                        <p>Sales Total</p>
                        <p style={{ opacity: 0 }}>test</p>
                        <h3>₹ {currencyFormatInt(salesDashboardDetails && salesDashboardDetails[totalSalesValue].reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v.total)), 0))}</h3>
                    </Col>
                </Row>
                <div className={classes.salesByLocradiabtn}>
                    <div className={classes.totalChartDiv}>
                        <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                            <RadioGroup
                                row
                                value={type}
                                onChange={(e) => handleTypeChange(e.target.value)}>
                                <FormControlLabel value="areas" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="City - Area" />
                                <FormControlLabel value="pins" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="City - Pincode" />
                                <FormControlLabel value="state" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="City - State" />
                            </RadioGroup>
                        </div>
                    </div>
                </div>
                <Row className={clsx(classes.salesByLochead)}>
                    <Col span={7}>
                        <p>City</p>
                    </Col>
                    <Col span={9}>
                        <p>{typeTitle}</p>
                    </Col>
                    <Col span={8} className={clsx(classes.textAlignRight)}>
                        <p>Sales Total</p>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: height }}>
                {
                    datas.length > 0 ? datas.map((data, i) => {
                        if (cI >= 3) {
                            cI = 0;
                        }
                        cI += 1;
                        //let d = 0;
                        return (
                            <Row key={i} gutter={5} type={'flex'} className={clsx(classes.salesByLocdetails)}>
                                <Col span={7}>
                                    <div className={clsx(colors[cI - 1], tBorder[cI - 1], classes.leftbox)}>
                                        <h6>{data?.name}</h6>
                                        <p>Sales Total</p>
                                        <h3>₹ {currencyFormatInt(data?.total)}</h3>
                                    </div>
                                </Col>
                                <Col span={17}>
                                    {
                                        type !== 'state' ? data[type].map((d, di) => {
                                            let per = 100 / data[type].length;
                                            return (
                                                <div key={`col_${di}`} className={clsx(colors[cI - 1], tBorder[cI - 1], classes.righttbox, data[type].length)}
                                                    style={{ height: data[type].length > 2 ? 'auto' : per + '%' }}>
                                                    <Row type={'flex'} key={di}>
                                                        {/* <div className={clsx(classes.rowLocationCalc, bBorder[cI - 1])}><div className={clsx(border[cI - 1])} style={{ width: `${parseInt((d?.total / data.total) * 100)}%` }}></div>
                                                            <div style={{ width: `calc(${100 - parseInt((d?.total / data.total) * 100)}% - 1px)` }}></div></div> */}
                                                        <Col style={{ width: "55%" }} className={clsx(border[cI - 1], classes.padding4)}>
                                                            <h6 className={classes.ellipse}>{d?.name || d?.code}</h6>
                                                        </Col>
                                                        <Col style={{ width: "45%" }} className={clsx(classes.textAlignRight, classes.padding4)}>
                                                            <p>₹ {currencyFormatInt(d?.total)}</p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        }) :
                                            <div className={clsx(classes.customStateH, colors[cI - 1], tBorder[cI - 1], classes.righttbox)}>
                                                <Row type={'flex'}>
                                                    <Col style={{ width: "55%" }} className={clsx(border[cI - 1], classes.padding4)}>
                                                        <h6>{data?.state}</h6>
                                                    </Col>
                                                    <Col style={{ width: "45%" }} className={clsx(classes.textAlignRight, classes.padding4)}>
                                                        <p>₹ {currencyFormatInt(data?.total)}</p>
                                                    </Col>
                                                </Row>
                                            </div>
                                    }
                                </Col>
                            </Row>
                        )

                    }) : 'No results found'
                }
            </div>
        </div>

    )
}